"use strict";

exports.__esModule = true;
exports["default"] = exports.HtmlIntroText = exports.HtmlIntro = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var HtmlIntroText = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "intro__HtmlIntroText",
  componentId: "sc-j2jad2-0"
})([""]);
exports.HtmlIntroText = HtmlIntroText;

var HtmlIntro = function HtmlIntro(_ref) {
  var className = _ref.className,
      dataTestId = _ref["data-test-id"],
      text = _ref.text;
  return /*#__PURE__*/_react["default"].createElement(HtmlIntroText, {
    className: className,
    "data-test-id": dataTestId
  }, text);
};

exports.HtmlIntro = HtmlIntro;
HtmlIntro.propTypes = {
  /** A string representing the name of the class */
  className: _propTypes.string,

  /** cypress test id */
  "data-test-id": _propTypes.string,

  /** HTML content */
  text: _propTypes.node
};
HtmlIntro.displayName = "Modules.HtmlIntro";
var _default = HtmlIntro;
exports["default"] = _default;